import { useState } from "react";

export default function CourseStatistics({ statisticsData, setCourseSelection }) {
    const [selection, setSelection] = useState(null);
    if (!statisticsData) {
        return <div>No data available</div>
    } else {
        const coursesArray = Object.entries(statisticsData.courses).map(([course, count]) => ({ course, count }));
        const sortedData = [...coursesArray].sort((a, b) => b.count - a.count);
        if (!selection) {
            setSelection(sortedData.map((course) => ({ name: course.course, termin1: true, termin2: true, termin3: true })));
        }

        const getValue = (index, termin) => {
            if (!selection) return true;
            return selection[index][termin];
        }

        const setValue = (index, termin, value) => {
            const newSelection = [...selection];
            newSelection[index][termin] = value;
            setSelection(newSelection);
        }

        console.log(selection);

        const warningMessage = (count, selected) => {
            if (count < 10 && selected > 1) {
                return "Nur ausreichend Teilnehmer für einen Kurs";
            } else if (count < 15 && selected > 2) {
                return "Nur ausreichend Teilnehmer für zwei Kurse";
            } else if (count < 21 && selected === 3) {
                return "Kursgröße bei 3 Kursen evtl. zu klein";
            } else if (selected < 3 && count > 20) {
                    return "Kursgröße bei weniger als 3 Kursen zu groß";
            } else {
                return "";
            }
        }

        const getSelectedCount = (index) => {
            if (!selection) return 3;
            const selected = selection[index];
            return Object.keys(selected).filter((termin) => selected[termin]).length - 1;
        }

        const getWarningColor = (count, selected) => {
            console.log(count, selected);
            if (count < 10 && selected > 1) {
                return 'red';
            } else if (count < 15 && selected === 3) {
                return 'orange';
            } else if (count > 20 && selected <3) {
                return 'red';
            } else {
                return 'black';
            }
        }
        const toNext = () => {
            const courses = [];
            for (let i = 0; i < sortedData.length; i++) {
                for (let j = 1; j <= 3; j++) {
                    if (getValue(i, `termin${j}`)) {
                        courses.push( { name: sortedData[i].course, termin: j });
                    }
                }
            }
            console.log(courses);
            setCourseSelection(courses);
        }

        return (
            <div>
                <h2>Kursübersicht</h2>
                <table style={{ padding: '20px', marginBottom: '20px' }}>
                    <thead>
                        <tr>
                            <th>Kurs</th>
                            <th>Anzahl</th>
                            <th>Termin 1</th>
                            <th>Termin 2</th>
                            <th>Termin 3</th>
                            <th>Hinweise</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((stat, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff' }}>
                                <td>{stat.course}</td>
                                <td>{stat.count}</td>
                                <td><input type="checkbox" onChange={(e) => setValue(index, 'termin1', e.target.checked)} checked={getValue(index, 'termin1')}/></td>
                                <td><input type="checkbox" onChange={(e) => setValue(index, 'termin2', e.target.checked)} checked={getValue(index, 'termin2')}/></td>
                                <td><input type="checkbox" onChange={(e) => setValue(index, 'termin3', e.target.checked)} checked={getValue(index, 'termin3')}/></td>
                                <td style={{ color: getWarningColor(stat.count, getSelectedCount(index)), textAlign: 'left' }}>{warningMessage(stat.count, getSelectedCount(index))}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>Anzahl Personen: {statisticsData.info.totalEntries}</p>
                <p>Anzahl Kurse: {statisticsData.info.totalCourses}</p>
                <p>Zielanzahl Personen pro Kurs: {Math.ceil(statisticsData.info.totalEntries / statisticsData.info.totalCourses)}</p>
                <button onClick={toNext}>Zur Einteilung</button>
            </div>
        )
    }
}